
// import util from '~/assets/js/util.mjs'

export default {
  props: {
    timetable: {
      type: Array,
      required: true,
    },
    hideDays: {
      type: String,
      default: null,
    },
    days: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 400,
    },
    // type: {
    //   type: String,
    //   required: true,
    // },
    // level: {
    //   type: String,
    //   required: true,
    // },
    // description: {
    //   type: Object,
    //   default: null,
    // },
  },
  data: function () {
    let allDays

    if (Array.isArray(this.days) && this.days.length) {
      allDays = this.days.slice()
    } else {
      allDays = this.timetable.reduce((tab, { day }) => {
        const dayExist = tab.find(({ name }) => name === day)
        if (!dayExist) {
          tab.push({
            name: day,
          })
        }
        return tab
      }, [])
    }

    return {
      isHydrated: false,
      allDays: allDays,
      times: this.calculateTimes(),
      reveal: false,
    }
  },
  computed: {
    // init
    breakpoint() {
      return this.isHydrated ? this.$vuetify.breakpoint : { smAndDown: '' } // Any constant default value would do here
    },
    isMobile() {
      return this.breakpoint.smAndDown
    },
  },
  mounted() {
    this.isHydrated = true
  },
  methods: {
    calculateTimes() {
      const tthis = this
      return tthis.timetable.reduce(
        (base, { start, end, display }) => {
          // ignore case
          if (
            !(
              !display ||
              (display == 'mobile' && this.isMobile) ||
              (display == 'desktop' && !this.isMobile)
            )
          )
            return base

          if (tthis.calcMinTotal(base.start) > tthis.calcMinTotal(start)) {
            base.start = start
          }
          if (tthis.calcMinTotal(base.end) < tthis.calcMinTotal(end)) {
            base.end = end
          }

          return base
        },
        {
          start: {
            hour: 30,
            min: 0,
          },
          end: {
            hour: 0,
            min: 0,
          },
        }
      )
    },
    filterActivities(dayName) {
      return this.timetable.filter(
        ({ day, display }) =>
          day === dayName &&
          (!display ||
            (display == 'mobile' && this.isMobile) ||
            (display == 'desktop' && !this.isMobile))
      )
    },
    isDaysHidden() {
      return (
        this.hideDays == 'true' ||
        (this.hideDays == 'mobile' && this.isMobile) ||
        (this.hideDays == 'desktop' && !this.isMobile)
      )
    },
    getCalendarStyle() {
      let style = { height: this.isMobile ? 'auto' : this.height + 'px' }

      if (this.isDaysHidden()) {
        Object.assign(style, { 'margin-top': '30px' })
      }

      return style
    },
    getActivityStyle(activity) {
      if (this.isMobile) return 'height: auto'

      // else
      const percent = this.calcPercentTime(activity.start, activity.end)
      const percentTop = this.calcPercentTop(activity.start, activity.end)

      const modif = activity.place ? '+ 29px' : '- 10px'
      const modifTop = activity.place ? '- 39px' : ''

      return `height: calc(${percent}% ${modif}); top: calc(${percentTop}% ${modifTop})`
    },
    displayTime(time) {
      return `${time.hour}h${time.min ? time.min : ''}`
    },
    calcMinTotal(time) {
      return time.hour * 60 + time.min
    },
    calcPercentTime(start, end) {
      const timeOfItem = this.calcMinTotal(end) - this.calcMinTotal(start)

      const scopeTime =
        this.calcMinTotal(this.times.end) - this.calcMinTotal(this.times.start)

      return (timeOfItem / scopeTime) * 100
    },
    calcPercentTop(start) {
      const scopeTime =
        this.calcMinTotal(this.times.end) - this.calcMinTotal(this.times.start)

      const fromTop =
        this.calcMinTotal(start) - this.calcMinTotal(this.times.start)

      if (!fromTop) return 0

      return (fromTop / scopeTime) * 100
    },
  },
}
